import {Component, OnInit} from '@angular/core';
import { DataService } from "../data.service";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrManager } from 'ng6-toastr-notifications';
import { dataType } from '../dataType';

@Component({
  selector: 'app-create-iam-user',
  templateUrl: './create-iam-user.component.html',
  styleUrls: ['./create-iam-user.component.css']
})
export class CreateIamUserComponent{

  public data = new dataType();
  public groups = [];

  ngOnInit(): void {
  
  }

  constructor(private dataService: DataService, private router: Router, private http: HttpClient, private toastr: ToastrManager,) {}

    addUser() {
    this.save();
  }

  private save(): void {
    this.dataService.addIamUser(this.data).subscribe((Data: any) => {
      console.log(Data);
      if (typeof Data == "string") {
        var newData = JSON.parse(Data);
      } else {
        var newData = Data;
      }
      console.log(newData);
      if (newData.Status == "Error") {
        // console.log(newData.Error.message);
        this.toastr.errorToastr(newData.Error.message, 'Oops!');

      } else if (newData.Status == "Success") {
        this.toastr.successToastr('User Created Successfully', 'Success!');
         this.router.navigate(["/iam"])
      }
     

    });
  }


}
